export default __webpack_public_path__ + "static/media/yezzy.e8158273.jpg";